import { render, staticRenderFns } from "./work-calendar-add.vue?vue&type=template&id=60099267"
import script from "./work-calendar-add.vue?vue&type=script&lang=js"
export * from "./work-calendar-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports